import { createSlice } from "@reduxjs/toolkit";
import { fetchDraftRFQs } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const draftRFQSlice = createSlice({
  name: "Draft RFQ",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDraftRFQs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDraftRFQs.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchDraftRFQs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export default draftRFQSlice.reducer;
